import React from 'react';
import '../styles/Services.css';

const services = [
  {
    title: 'Academic Programs',
    description: 'Undergraduate and postgraduate degrees in various disciplines',
    items: ['Bachelor’s Degrees', 'PhD Research', 'Foundation Courses'],
  },
  {
    title: 'Online Learning',
    description: 'Flexible digital education accessible from anywhere',
    items: ['Self-paced Courses', 'Interactive Webinars', 'Certificate Programs', 'Mobile Learning'],
  },
  {
    title: 'Corporate Training',
    description: 'Customized programs for organizational development',
    items: ['Leadership Development', 'Technical Skills', 'Team Building', 'Compliance Training'],
  },
  {
    title: 'Professional Development',
    description: 'Continuous skill enhancement for professionals',
    items: ['Industry Certifications', 'Skill Enhancement', 'Career Coaching', 'Networking Events'],
  },
  {
    title: 'Executive Education',
    description: 'Premium programs for senior professionals',
    items: ['Executive MBA', 'Leadership Programs', 'Strategic Management', 'Global Business'],
  },
  {
    title: 'Short Courses',
    description: 'Quick skill acquisition for focused outcomes',
    items: ['Weekend Workshops', 'Intensive Bootcamps', 'Micro-credentials', 'Practical Training'],
  },
];

const Services = () => (
  <section className="services">
    <h2>Our Services</h2>
    <p className="intro">Comprehensive educational solutions tailored to meet diverse learning needs.</p>
    <div className="service-grid">
      {services.map((service, index) => (
        <div key={index} className="service-card">
          <h3>{service.title}</h3>
          <p>{service.description}</p>
          <ul>
            {service.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="cta">
      <h3>Ready to Start Learning?</h3>
      <p>Explore our full catalog of programs and find the perfect fit for your educational goals</p>
      <button>Get Program Details</button>
    </div>
  </section>
);

export default Services;
